import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  PRTemplateSelectedIds: [],
  PRTemplateTreeData: [],
  PRTemplateAppliedData: [],
  PRTemplateSearchQuery: "",
  PRTemplateExpandedItems: [],
};

const PRTemplateTreeSlice = createSlice({
  name: "PRTemplateTree",
  initialState,
  reducers: {
    setPRTemplateSelectedIds: (state, action) => {
      state.PRTemplateSelectedIds = action.payload;
    },
    setPRTemplateTreeData: (state, action) => {
      state.PRTemplateTreeData = action.payload;
    },
    setPRTemplateAppliedData: (state, action) => {
      state.PRTemplateAppliedData = action.payload;
    },
    setPRTemplateSearchQuery: (state, action) => {
      state.PRTemplateSearchQuery = action.payload;
    },
    resetPRTemplateSelection: (state) => {
      state.PRTemplateSelectedIds = [];
      state.PRTemplateAppliedData = [];
    },
    setPRTemplateExpandedItems: (state, action) => {
      state.PRTemplateExpandedItems = action.payload;
    },
  },
});

export const {
  setPRTemplateSelectedIds,
  setPRTemplateTreeData,
  setPRTemplateAppliedData,
  setPRTemplateSearchQuery,
  resetPRTemplateSelection,
  setPRTemplateExpandedItems,
} = PRTemplateTreeSlice.actions;

export default PRTemplateTreeSlice.reducer;
